
import React from 'react';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Label } from '@/components/ui/label';
import { BannerSize, BANNER_SIZES } from '@/types/banner';

interface AIBannerSizeSelectorProps {
  selectedSize: BannerSize;
  onSizeChange: (size: BannerSize) => void;
  showAllSizes?: boolean;
}

const AIBannerSizeSelector: React.FC<AIBannerSizeSelectorProps> = ({
  selectedSize,
  onSizeChange,
  showAllSizes = false
}) => {
  // We'll show a curated list of common sizes unless showAllSizes is true
  const displaySizes = showAllSizes 
    ? BANNER_SIZES 
    : BANNER_SIZES.filter(size => 
        ['medium_rectangle', 'leaderboard', 'large_rectangle', 'half_page', 'mobile_banner'].includes(size.value)
      );
  
  return (
    <div className="space-y-4">
      <RadioGroup 
        value={selectedSize} 
        onValueChange={(value) => onSizeChange(value as BannerSize)}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3"
      >
        {displaySizes.map((size) => (
          <div key={size.value} className="flex items-center space-x-2">
            <RadioGroupItem value={size.value} id={size.value} />
            <Label 
              htmlFor={size.value} 
              className="flex flex-col cursor-pointer"
            >
              <span className="font-medium">{size.name}</span>
              <span className="text-sm text-gray-500">
                {size.width}x{size.height}px
              </span>
            </Label>
          </div>
        ))}
      </RadioGroup>
    </div>
  );
};

export default AIBannerSizeSelector;
